import React from 'react';
import {
    ListSingleColumnIcon,
    ListDoubleColumnIcon,
    FilledListSingleColumnIcon,
    FilledListDoubleColumnIcon,
    ListQuartetColumnIcon,
    ListOctalColumnIcon,
} from 'components/icons';
import styled from 'styled-components';

const ListingViewSection = ({ isDesktop, listingType, changeListingType }) => (
    <ListingColumnViewSection>
        <Wrapper show={isDesktop}>
            <ListIconWrapper onClick={() => changeListingType('quartet')}>
                <ListQuartetColumnIcon
                    fill={listingType.name === 'quartet' && 'black'}
                />
            </ListIconWrapper>
            <ListIconWrapper onClick={() => changeListingType('octal')}>
                <ListOctalColumnIcon
                    fill={listingType.name === 'octal' && 'black'}
                />
            </ListIconWrapper>
        </Wrapper>

        <Wrapper show={!isDesktop}>
            <ListIconWrapper onClick={() => changeListingType('single')}>
                {listingType.name === 'single' ? (
                    <FilledListSingleColumnIcon />
                ) : (
                    <ListSingleColumnIcon />
                )}
            </ListIconWrapper>
            <ListIconWrapper onClick={() => changeListingType('double')}>
                {listingType.name === 'double' ? (
                    <FilledListDoubleColumnIcon />
                ) : (
                    <ListDoubleColumnIcon />
                )}
            </ListIconWrapper>
        </Wrapper>
    </ListingColumnViewSection>
);

const Wrapper = styled.div`
    align-items: center;
    justify-content: center;
    display: ${({ show }) => (show ? 'flex' : 'none')};
`;
const ListingColumnViewSection = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 10px 15px;

    @media (max-width: 1024px) {
        margin-bottom: 6px;
    }
`;
const ListIconWrapper = styled.div`
    margin-left: 16px;
    cursor: pointer;
`;
export default ListingViewSection;
